// extracted by mini-css-extract-plugin
module.exports = {"SocialMediaAnchorTag":"SocialMediaLink_SocialMediaAnchorTag__1tlnN","SocialMediaIcon":"SocialMediaLink_SocialMediaIcon__33_l1"};